/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Platform_DesktopInputs */

const en_pricing_platform_desktop = /** @type {(inputs: Pricing_Platform_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desktop app`)
};

const es_pricing_platform_desktop = /** @type {(inputs: Pricing_Platform_DesktopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicación de escritorio`)
};

/**
* | output |
* | --- |
* | "Desktop app" |
*
* @param {Pricing_Platform_DesktopInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_platform_desktop = /** @type {((inputs?: Pricing_Platform_DesktopInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Platform_DesktopInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_platform_desktop(inputs)
	return en_pricing_platform_desktop(inputs)
});